import type fr from '../fr/chat';

const en: typeof fr = {
  title: 'Messages',
  empty: { title: 'No conversations yet.', description: 'Write to us with any question about your cleanings.' },
  noSubject: 'No subject',
  unassigned: 'Unassigned',
  priorityHigh: 'High priority',
  you: 'You',
  team: 'The team',
  internalNote: 'Internal note',
  reply: 'Reply',
  composerMode: 'Message type',
  placeholder: 'Write a message…',
  notePlaceholder: 'Note visible to the team only (e.g. @Sophie check the price)',
  noteHint: 'Internal notes are never visible to the client or the employee.',
  send: 'Send',
  read: 'Read',
  sent: 'Sent',
  statusChanged: 'Status: {{status}}',
  newConversation: 'New message',
  subject: 'Subject',
  message: 'Message',
  start: 'Send message',
  back: 'All conversations',
};
export default en;
